<template>
  <div v-if="$store.state.brokerModule.broker != null && $store.state.brokerModule.broker.user_id == $store.state.user.id" 
    class="max-w-2xl m-auto">

    <div class="text-2xl font-thin">
      Welcome {{ $store.state.brokerModule.broker.first_name }}

      <img src="" />
    </div>

    <div class="mt-8 bg-gray-200 p-6">
      <div class="text-center text-base uppercase font-semibold">Getting started</div>

      <div class="mt-6">
        <iframe 
          width="100%" 
          height="330" 
          src="https://www.youtube.com/embed/73qFVWXpM4Y?rel=0" 
          frameborder="0" 
          allowfullscreen></iframe>
      </div>

      <div class="overflow-hidden mt-4">
        <div class="float-left">
          <a href="#"
            v-on:click.prevent="addNewClient()"
            class="text-white uppercase bg-blue-500 font-semibold inline-block no-underline hover:bg-blue-500 text-xs"
            style="padding:12px;">Add a New Client</a>
        </div>

        <div class="float-left ml-4">
          <router-link :to="{ name : 'client-list' }" tag="a" class="text-white bg-green-500 font-semibold inline-block no-underline hover:bg-green-600 text-xs" 
            style="padding:12px;">View Client List</router-link>
        </div>

        <div class="float-right overflow-hidden">
          <div class="float-left mr-2">
            <input type="text" class="input-standard" placeholder="Search an active client" v-model="query" />
          </div>

          <div class="float-left">
            <button class="text-white uppercase bg-blue-500 font-semibold inline-block no-underline hover:bg-blue-500 text-xs"
              style="padding:12px;"
              v-on:click="search()">Search</button>
          </div>
        </div>
      </div>

      <div class="text-center mt-8 text-base" style="line-height:30px;">
        <input type="checkbox" 
          id="input-show-home-page" 
          :checked="broker.should_show_landing"
          v-bind:value="broker.should_show_landing"
          v-on:change="should_show_landingChanged($event.target.checked)" 
          style="bottom:1px;position:relative;" />
        <label for="input-show-home-page" class="ml-2">Show this page each time you log in</label>
        <div class="mt-2">(You can always return here by clicking "Home")</div>
      </div>
    </div>

    <div class="text-center py-6">
      <Footer></Footer>
    </div>

    <ConfirmRegistrationModal />
    <FreeVersionNoticeModal />
  </div>
</template>

<script>
  import ConfirmRegistrationModal from '@/shared/components/modals/ConfirmRegistrationModal'
  import FreeVersionNoticeModal   from '@/shared/components/modals/FreeVersionNoticeModal'
  import Footer                   from '@/shared/components/Footer'

  export default {
    components: {
      ConfirmRegistrationModal,
      FreeVersionNoticeModal,
      Footer
    },

    data() {
      return {
        query : null,
        broker: _.cloneDeep(this.$store.state.brokerModule.broker)
      }
    },

    created() {
      // broker can only been seen if current user == current broker
      if(this.$store.state.brokerModule.broker != null && this.$store.state.brokerModule.broker.user_id == this.$store.state.user.id) {

      } else {
        this.$router.push({
          name: 'auth-login'
        })
      }
    },

    mounted() {
      if(this.$route.params.showConfirmRegistration != null && this.$route.params.showConfirmRegistration == 1) {
        this.$modal.show('confirm-registration-modal')
      }

      // console.log(this.$store.state.user)

      if(this.$store.state.user.free_version_notice) {
        this.$modal.show('free-version-notice-modal')
      }
    },

    methods : {
      should_show_landingChanged(shouldShow) {
        this.updateBroker(this.broker, 'should_show_landing', shouldShow)
      },

      search() {
        this.$router.push({
          name  : 'client-list-search',
          params: {
            query     : this.query,
            clientType: 'active',
            status    : 'all',
            access    : 'all',
            orderBy   : 'last_activity_timestamp',
            orderType : 'desc',
            limit     : 30,
            offset    : 0
          } 
        })
      }
    }
  }
</script>